export default __webpack_public_path__ + "static/media/paystack-logo.0ef1ef27.png";